import type { Fact } from "../../common/fact-table";
import { graphemes } from "../../common/graphemes";
import { documentLines } from "./lines";

// What a count is of is the thing being counted and not the box it is in, so the same six answer for either text.
export function counts(text: string): Fact[] {
  const characters = [...text].length;
  const clusters = graphemes(text).length;
  const trimmed = text.trim();
  return [
    { label: "Characters", value: String(characters) },
    // Worth a row only where the two disagree, which is a flag, a family or a letter with an accent written after it.
    { label: "Graphemes", value: clusters === characters ? "" : String(clusters) },
    { label: "Without spaces", value: String([...text.replace(/\s/gu, "")].length) },
    { label: "Words", value: String(trimmed === "" ? 0 : trimmed.split(/\s+/u).length) },
    { label: "Lines", value: String(text === "" ? 0 : documentLines(text).length) },
    { label: "Bytes (UTF-8)", value: String(new TextEncoder().encode(text).length) },
  ];
}
